import {
    Card,
    CardHeader,
    CardTitle,
    CardContent,
} from "../../../components/ui/card";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import Table from "../../../components/table/table-2";
import { useState } from "react";
import { columns, data } from "../../../data/admin/role/create-doctor";
import FormRenderer from "../../../components/input-field/form-renderer";
import { createDoctorFields } from "../../../config/role/create-doctor";
import { isFormValid } from "../../../utils/validators";
import { StethoscopeIcon } from "lucide-react";
const CreateDoctor = () => {

    const [form, setForm] = useState({});
    const [fee, setFee] = useState('');
    const [days, setDays] = useState([]);
    const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri"];
    const handleSelect = (day) => {
        setDays((prev) =>
            prev.includes(day)
                ? prev.filter((d) => d !== day)
                : [...prev, day]
        );
    };

    const handleFeeChange = (e) => {
        const value = e.target.value;

        if (value === "") {
            setFee("");
            return;
        }

        if (/^\d+$/.test(value)) {
            setFee(value);
        }
    };

    return (
        <div className="sm:p-2">
                <h2 className="text-xl pl-4 flex items-center justify-start gap-2 md:text-2xl text-black font-bold mb-4 md:mb-8">
                    <StethoscopeIcon className="text-purple-700"/>
                    Create Doctor
                </h2>

                <div className="grid grid-cols-1 gap-8">
                    <Card className=" rounded-xl bg-white  border-none ">
                        <div className="w-full p-2 md:p-6 flex flex-col">
                            <div className="w-full">
                                <FormRenderer
                                    fields={createDoctorFields}
                                    values={form}
                                    setValues={setForm}
                                />
                            </div>
                            <div className="w-full flex flex-col gap-2 mt-2">
                                    <label className="font-semibold text-gray-700 mb-2 block">
                                        OPD Timing
                                    </label>
                                    <div className="flex items-center justify-center w-full gap-6">
                                        {weekDays.map((day) => (
                                            <div
                                                key={day}
                                                className="flex  flex-col items-center justify-center gap-2 text-sm bg-[#f1f5ff] w-full p-2 rounded "
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={days.includes(day)}
                                                    onChange={() => handleSelect(day)}
                                                    className="cursor-pointer"
                                                />
                                                <span className="items-center">{day}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <p className="text-xs text-gray-500 mt-2">
                                        Selected: {days.join(", ") || "None"}
                                    </p>
                            </div>

                            <div className="flex flex-row w-1/2 gap-2">
                                <div className=" w-full lg:w-1/4 flex flex-col gap-2 mt-2">
                                    <div>
                                        <label className="font-semibold text-gray-700">
                                            Consultation Fee (₹)
                                        </label>
                                    </div>
                                    <div className="relative mb-4">
                                        <div>
                                            <Input
                                                type="number"
                                                name="fee"
                                                inputMode="numeric"
                                                min={0}
                                                value={fee}
                                                onChange={handleFeeChange}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "e" || e.key === "E") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                placeholder="Consultation Fee (₹)"
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-3">
                                <Button 
                                  disabled={!isFormValid(createDoctorFields, form)}
                                variant="admin.secondary">
                                    Summit
                                </Button>
                            </div>
                        </div>
                    </Card>

                    <Card className="rounded-xl border-none bg-white p-2">
                        <CardHeader>
                            <CardTitle className="text-md md:text-xl text-gray-600">Doctor List</CardTitle>
                        </CardHeader>
                        <CardContent className=" text-[#081a3a] text-2xl md:text-4xl font-bold">
                            <Table columns={columns} data={data} rowsPerPage={4} headerBg="bg-[#0a1f44]" headerText="text-white" />
                        </CardContent>
                    </Card>
                </div>
        </div>
    );
};

export default CreateDoctor;
